export const BRANCH_PANEL_ID = "branch";
export const BRANCH_ROW_ESTIMATED_HEIGHT = 52;
